import React, { useEffect, useRef, useState } from 'react';

import AdditionalSwatchSelectionMenu from '../AdditionalSwatchSelectionMenu';
import CTAButtonWrapper from '../../../common/CTAButtonWrapper';
import Collapse from 'react-bootstrap/Collapse';
import PropTypes from 'prop-types';
import styles from './AdditionalSwatchSelector.scss';

const AdditionalSwatchSelector = ({ question, onSelectOption }) => {
  const menuHolderRef = useRef(null);
  const menuRef = useRef(null);

  const [showButton, setShowButton] = useState(true);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const handleClickOutsideMenu = (e) => {
      if (!!menuRef && !!menuRef.current && !menuRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutsideMenu);
      document.addEventListener('touchstart', handleClickOutsideMenu);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideMenu);
      document.removeEventListener('touchstart', handleClickOutsideMenu);
    };
  }, [showMenu]);

  const menuHolderId = 'additional-swatch-selection-menu-holder';

  let { questionLabel } = question;
  questionLabel = (questionLabel || '').trim();
  if (questionLabel.endsWith(':')) questionLabel = questionLabel.slice(0, questionLabel.length - 1);

  return (
    <div className={styles['additional-swatch-selector']}>
      {showButton && (
        <CTAButtonWrapper
          aria-controls={menuHolderId}
          aria-expanded={showMenu}
          className={styles['show-menu-button']}
          leftIcon={{
            dark: '/resources/assets/ui/nextgen/add.svg',
            light: '/resources/assets/ui/nextgen/add_light.svg',
          }}
          text={`Add Another ${questionLabel}`}
          type="button"
          variant="secondary"
          onClick={() => setShowMenu(true)}
        />
      )}

      <Collapse
        appear
        in={showMenu}
        mountOnEnter
        unmountOnExit
        onEnter={() => setShowButton(false)}
        onEntered={() => {
          if (!!menuRef && !!menuRef.current) {
            menuRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            menuRef.current.focus();
          }
        }}
        onExited={() => setShowButton(true)}>
        <div id={menuHolderId} ref={menuHolderRef}>
          <AdditionalSwatchSelectionMenu
            question={question}
            ref={menuRef}
            onClose={() => setShowMenu(false)}
            onSelectOption={onSelectOption}
          />
        </div>
      </Collapse>
    </div>
  );
};

AdditionalSwatchSelector.propTypes = {
  question: PropTypes.shape({
    code: PropTypes.string.isRequired,
    isRealParentChildQuestion: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
    mandatoryFlag: PropTypes.string.isRequired,
    needToReloadUniqueOptions: PropTypes.bool.isRequired,
    questionId: PropTypes.number.isRequired,
    questionLabel: PropTypes.string.isRequired,
    questionText: PropTypes.string.isRequired,
    questionType: PropTypes.oneOf([0, 1, 2, 3]).isRequired,
    representationType: PropTypes.oneOf([0, 1]).isRequired,
    sampleQuestionText: PropTypes.string,
    selectionType: PropTypes.oneOf([0, 1]).isRequired,
    sequence: PropTypes.number.isRequired,
    thumbnailType: PropTypes.oneOf([0, 1, 2, 3]).isRequired,
  }).isRequired,
  onSelectOption: PropTypes.func.isRequired,
};

export default AdditionalSwatchSelector;
